import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from './services/loader.service';


@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loadingService: LoaderService
  ) {}


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //console.log('caught')
    const jwtToken = localStorage.getItem('jwtToken');

    this.loadingService.show();

    let apiRequest = request;
    if (jwtToken) {
      apiRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
    }

    return next.handle(apiRequest).pipe(
      finalize(() => {
        this.loadingService.hide();
      })
    );
  }
}
